import { TranslatedProperty } from '@/core/models/TranslatedProperty';

export enum TeamTaxDiscountTypeKey {
   ClassicShifts = 'classic-shifts',
   Night = 'night',
   ContiniousOperation = 'continious-operation',
   BisVariant = 'bis-variant',
   WorkingInRealEstateCondition = 'working-in-real-estate-condition',
   NoExemption = 'no-exemption',
   BisShifts = 'bis-shifts',
   ContiniousOperationBis = 'continious-operation-bis',
}

export interface TeamTaxDiscountType {
   id: number;
   key: TeamTaxDiscountTypeKey;
   name: TranslatedProperty;
}
